import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, ViewChildren, ViewChild, Output, NgModule } from '@angular/core';
import { map, take, takeUntil, distinctUntilChanged } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';
import { saveAs } from 'file-saver';
import * as i1 from '@angular/common/http';
import * as i5 from '@angular/forms';
import { Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import * as moment from 'moment';
import { sync_profile_code } from 'permission-library';
import * as i12 from '@angular/material/expansion';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import * as errorUtils from 'error-message-utility';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import * as i11 from '@angular/material/table';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'dirty-check-store';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { DeleteDialogLibraryComponent, DeleteDialogLibraryModule } from 'delete-dialog-library';
import { environment } from 'environment-configurations';
import { acceptedFileTypes } from 'app-models';
import { CustomErrorToastComponent } from 'custom-error-toast';
import * as i1$1 from 'cache-country-list';
import * as i3 from 'ngx-toastr';
import * as i4 from 'reference-library';
import * as i6 from '@angular/router';
import * as i7 from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import * as i8 from '@ngrx/store';
import * as i9 from 'primeng/dynamicdialog';
import * as i10 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i13 from '@angular/material/card';
import { MatCardModule } from '@angular/material/card';
import * as i14 from '@angular/material/stepper';
import { MatStepperModule } from '@angular/material/stepper';
import * as i15 from 'primeng/dropdown';
import * as i16 from 'year-date-picker-library';
import { YearDatePickerLibraryModule } from 'year-date-picker-library';
import * as i17 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i18 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i19 from '@angular/material/datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import * as i20 from '@angular/material/chips';
import { MatChipsModule } from '@angular/material/chips';
import * as i21 from 'file-upload-deafult-library';
import { FileUploadDeafultLibraryModule } from 'file-upload-deafult-library';
import * as i22 from 'save-as-draft';
import { SaveAsDraftModule } from 'save-as-draft';
import * as i23 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i24 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i25 from 'primeng/button';
import * as i26 from 'primeng/tooltip';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDividerModule } from '@angular/material/divider';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { AvatarModule } from 'ngx-avatar';
import { MatTabsModule } from '@angular/material/tabs';
import { PrimengLibraryModule } from 'primeng-library';
import * as i1$2 from 'ngx-mask';
import { NgxMaskModule } from 'ngx-mask';
import { FileDownloadLibraryModule } from 'file-download-library';

class AddEducationDetailsService {
    constructor(http) {
        this.http = http;
        this.countryDataSource = new BehaviorSubject({ listCountries: [] });
        this.deletedfile$ = new BehaviorSubject({});
        this.uploaded$ = new BehaviorSubject({});
        this.dependentProfileSubject = new BehaviorSubject({});
        this.onLifeStorySubTabs = new Subject();
        this.isExpired = false;
        this.isEducationDetailsChanged = new Subject();
        this.selfBeneficiaryDetailChange = new Subject();
        this.newSubDependentCreated = new Subject();
    }
    getStates(countryCode) {
        return this.http.get(`/countries/states?countryCode=${countryCode}`).pipe(map((response) => {
            if (response.status) {
                return response.data;
            }
        }));
    }
    // getEducationDetails(petitionId: number, superTaskId: number, taskId: number, familyId?: number) {
    getEducationDetails(visatype, caseType, caseId, synctype, superTaskId, subTaskId) {
        let isUsedForBenEdit;
        if (sessionStorage.getItem('wizardTID')) {
            isUsedForBenEdit = false;
        }
        else {
            isUsedForBenEdit = true;
        }
        const url = `/${visatype}/${caseType}/${caseId}/${synctype}?superTaskId=${superTaskId}&taskId=${subTaskId}&isUsedForBenEdit=${isUsedForBenEdit}`;
        return this.http.get(url).pipe(map((data) => data));
    }
    saveEducatinDegreeDetails(petitionId, payload, familyId) {
        const url = `/petition/saveEducation/${petitionId}`;
        return this.http.post(url, payload).pipe(map((response) => response));
    }
    deleteEducatinDegreeDetails(visatype, caseType, caseId, synctype, superTaskId, subTaskId, educationId) {
        return this.http.delete(`/${visatype}/${caseType}/${caseId}/${synctype}/${educationId}?superTaskId=${superTaskId}&taskId=${subTaskId}`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    deletefile(beneficiaryId) {
        this.deletedfile$.next(true);
    }
    checkBeneEditPermission() {
        const permission = JSON.parse(sessionStorage.getItem('currentUser'));
        return permission ? permission['permissions'].length > 0 && permission['permissions'].find(x => x === 'EDIT_BENEFICIARY') ? true : false : false;
        // return permission['permissions'].length>0 && permission['permissions'].find(x=> x === 'DELETE_BENEFICIARY')? true : false;
    }
    checkValidity() {
        return this.isExpired;
    }
    educationDetailsChanged(data) {
        this.isEducationDetailsChanged.next(data);
    }
    changeDependentProfileID(dependentId, beneficiaryType) {
        this.dependentProfileSubject.next({ dependentId: dependentId, beneficiaryType: beneficiaryType });
    }
    downloadDocuments(path, fileName) {
        this.http.get(path, { responseType: "arraybuffer" })
            .pipe(take(1))
            .subscribe(pdf => {
            const blob = new Blob([pdf], { type: 'application/pdf' });
            saveAs(blob, fileName);
        });
    }
    genericGetUploadDocument(useCase, useCaseId, categoryName, entityId, useEntityId, familyId) {
        const entityUrlString = (useEntityId) ? `/entity/${entityId}` : '';
        const profileFamilyString = familyId ? `?familyId=${familyId}` : '';
        return this.http.get(`/document/${useCase}/${useCaseId}/category/${categoryName}${entityUrlString}${profileFamilyString}`).pipe(map((response) => {
            if (response.status === 200) {
                response.data = response.data.filter(x => x.fileLocation !== null);
                return response;
            }
            return response;
        }));
    }
}
AddEducationDetailsService.ɵfac = function AddEducationDetailsService_Factory(t) { return new (t || AddEducationDetailsService)(i0.ɵɵinject(i1.HttpClient)); };
AddEducationDetailsService.ɵprov = i0.ɵɵdefineInjectable({ token: AddEducationDetailsService, factory: AddEducationDetailsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddEducationDetailsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function AddEducationDetailsComponent_ng_container_1_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0, "Degree Details");
} }
function AddEducationDetailsComponent_ng_container_1_span_52_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span");
} }
function AddEducationDetailsComponent_ng_container_1_span_54_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 70);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r9.getGlobalErrorMessages("ZIPCODE_ONLY"), " ");
} }
function AddEducationDetailsComponent_ng_container_1_div_61_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelementStart(1, "div", 20);
    i0.ɵɵelementStart(2, "label", 21);
    i0.ɵɵtext(3, "State");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "p-dropdown", 71);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r10.listStates);
} }
function AddEducationDetailsComponent_ng_container_1_div_62_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelementStart(1, "div", 20);
    i0.ɵɵelementStart(2, "label", 21);
    i0.ɵɵtext(3, "State");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "input", 72);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function AddEducationDetailsComponent_ng_container_1_div_74_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 70);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r12.getGlobalErrorMessages("INVALID_YEAR"), " ");
} }
function AddEducationDetailsComponent_ng_container_1_div_75_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 70);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r25.getGlobalErrorMessages("INVALID_YEAR"), " ");
} }
function AddEducationDetailsComponent_ng_container_1_div_75_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelementStart(1, "div", 20);
    i0.ɵɵelementStart(2, "label", 34);
    i0.ɵɵtext(3, "End Year");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "year-date-picker-library", 35);
    i0.ɵɵtemplate(5, AddEducationDetailsComponent_ng_container_1_div_75_div_5_Template, 2, 1, "div", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("yearFormControl", ctx_r13.addDegreeCourceForm.controls.endYear);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.showEndYearValidationError);
} }
function AddEducationDetailsComponent_ng_container_1_div_85_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 70);
    i0.ɵɵtext(1, " Awarded Date cannot be less than End year ");
    i0.ɵɵelementEnd();
} }
function AddEducationDetailsComponent_ng_container_1_lib_save_as_draft_89_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "lib-save-as-draft", 73);
    i0.ɵɵlistener("onClickSaveAsDraft", function AddEducationDetailsComponent_ng_container_1_lib_save_as_draft_89_Template_lib_save_as_draft_onClickSaveAsDraft_0_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(2); return ctx_r26.saveAsDraft($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r16.isSaveAsDraftDisabled)("formToBeSaved", ctx_r16.addDegreeCourceForm);
} }
function AddEducationDetailsComponent_ng_container_1_ng_template_104_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0, "Related Courses");
} }
function AddEducationDetailsComponent_ng_container_1_mat_chip_114_mat_icon_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 76);
    i0.ɵɵtext(1, "cancel");
    i0.ɵɵelementEnd();
} }
function AddEducationDetailsComponent_ng_container_1_mat_chip_114_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-chip", 74);
    i0.ɵɵlistener("removed", function AddEducationDetailsComponent_ng_container_1_mat_chip_114_Template_mat_chip_removed_0_listener() { i0.ɵɵrestoreView(_r31); const cource_r28 = ctx.$implicit; const ctx_r30 = i0.ɵɵnextContext(2); return ctx_r30.remove(cource_r28); });
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, AddEducationDetailsComponent_ng_container_1_mat_chip_114_mat_icon_2_Template, 2, 0, "mat-icon", 75);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const cource_r28 = ctx.$implicit;
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("selectable", ctx_r19.selectable)("removable", ctx_r19.removable);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", cource_r28.courseName, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r19.removable);
} }
function AddEducationDetailsComponent_ng_container_1_div_121_tr_5_mat_icon_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 86);
    i0.ɵɵtext(1, "delete_forever");
    i0.ɵɵelementEnd();
} }
function AddEducationDetailsComponent_ng_container_1_div_121_tr_5_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 80);
    i0.ɵɵelementStart(1, "td", 81);
    i0.ɵɵelementStart(2, "div", 82);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td", 83);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "td", 84);
    i0.ɵɵlistener("click", function AddEducationDetailsComponent_ng_container_1_div_121_tr_5_Template_td_click_6_listener() { i0.ɵɵrestoreView(_r37); const i_r34 = ctx.index; const ctx_r36 = i0.ɵɵnextContext(3); return ctx_r36.deleteEducation(i_r34); });
    i0.ɵɵtemplate(7, AddEducationDetailsComponent_ng_container_1_div_121_tr_5_mat_icon_7_Template, 2, 0, "mat-icon", 85);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const course_r33 = ctx.$implicit;
    const i_r34 = ctx.index;
    const ctx_r32 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i_r34 + 1, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(course_r33.courseName);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r32.viewMode);
} }
function AddEducationDetailsComponent_ng_container_1_div_121_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 77);
    i0.ɵɵelementStart(1, "h5");
    i0.ɵɵtext(2, "Added Courses");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "table", 78);
    i0.ɵɵelementStart(4, "tbody");
    i0.ɵɵtemplate(5, AddEducationDetailsComponent_ng_container_1_div_121_tr_5_Template, 8, 3, "tr", 79);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r20.listCourses);
} }
function AddEducationDetailsComponent_ng_container_1_button_126_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 68);
    i0.ɵɵtext(1, " Back ");
    i0.ɵɵelementEnd();
} }
function AddEducationDetailsComponent_ng_container_1_button_128_Template(rf, ctx) { if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 87);
    i0.ɵɵlistener("click", function AddEducationDetailsComponent_ng_container_1_button_128_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r39); i0.ɵɵnextContext(); const _r6 = i0.ɵɵreference(9); const ctx_r38 = i0.ɵɵnextContext(); ctx_r38.closeForm(); return _r6.reset(); });
    i0.ɵɵtext(1, " Close ");
    i0.ɵɵelementEnd();
} }
function AddEducationDetailsComponent_ng_container_1_ng_template_132_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0, "Related Documents");
} }
function AddEducationDetailsComponent_ng_container_1_div_146_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r43 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 87);
    i0.ɵɵlistener("click", function AddEducationDetailsComponent_ng_container_1_div_146_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r43); i0.ɵɵnextContext(2); const _r6 = i0.ɵɵreference(9); const ctx_r42 = i0.ɵɵnextContext(); ctx_r42.closeForm(); return _r6.reset(); });
    i0.ɵɵtext(1, " Close ");
    i0.ɵɵelementEnd();
} }
function AddEducationDetailsComponent_ng_container_1_div_146_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r45 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 90);
    i0.ɵɵlistener("click", function AddEducationDetailsComponent_ng_container_1_div_146_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r45); i0.ɵɵnextContext(2); const _r6 = i0.ɵɵreference(9); const ctx_r44 = i0.ɵɵnextContext(); ctx_r44.addNewDegree(); return _r6.reset(); });
    i0.ɵɵtext(1, " Add New Degree ");
    i0.ɵɵelementEnd();
} }
function AddEducationDetailsComponent_ng_container_1_div_146_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 88);
    i0.ɵɵtemplate(1, AddEducationDetailsComponent_ng_container_1_div_146_button_1_Template, 2, 0, "button", 64);
    i0.ɵɵtemplate(2, AddEducationDetailsComponent_ng_container_1_div_146_button_2_Template, 2, 0, "button", 89);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r24.modeVal);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r24.viewMode);
} }
const _c0 = function (a0) { return { disabledView: a0 }; };
const _c1 = function (a0) { return { "im-input-error": a0 }; };
function AddEducationDetailsComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r47 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 9);
    i0.ɵɵelementStart(2, "button", 10);
    i0.ɵɵlistener("click", function AddEducationDetailsComponent_ng_container_1_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r47); const _r6 = i0.ɵɵreference(9); const ctx_r46 = i0.ɵɵnextContext(); ctx_r46.toggleExpansion(); return _r6 == null ? null : _r6.reset(); });
    i0.ɵɵtext(3, " Add / Edit Education ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-accordion");
    i0.ɵɵelementStart(5, "mat-expansion-panel", 11);
    i0.ɵɵelementStart(6, "mat-card");
    i0.ɵɵelementStart(7, "div", 9);
    i0.ɵɵelementStart(8, "mat-horizontal-stepper", 12, 13);
    i0.ɵɵelementStart(10, "mat-step", 14);
    i0.ɵɵelementStart(11, "form", 15);
    i0.ɵɵtemplate(12, AddEducationDetailsComponent_ng_container_1_ng_template_12_Template, 1, 0, "ng-template", 16);
    i0.ɵɵelementStart(13, "div", 17);
    i0.ɵɵelementStart(14, "div", 18);
    i0.ɵɵelementStart(15, "div", 19);
    i0.ɵɵelementStart(16, "div", 20);
    i0.ɵɵelementStart(17, "label", 21);
    i0.ɵɵtext(18, "Degree");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(19, "p-dropdown", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 19);
    i0.ɵɵelementStart(21, "div", 20);
    i0.ɵɵelementStart(22, "label", 21);
    i0.ɵɵtext(23, "Field of study");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(24, "input", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "div", 19);
    i0.ɵɵelementStart(26, "div", 20);
    i0.ɵɵelementStart(27, "label", 21);
    i0.ɵɵtext(28, "Grade/CGPA/Percentage");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(29, "input", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "div", 9);
    i0.ɵɵelementStart(31, "div", 19);
    i0.ɵɵelementStart(32, "div", 20);
    i0.ɵɵelementStart(33, "label", 21);
    i0.ɵɵtext(34, "University Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(35, "input", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(36, "div", 9);
    i0.ɵɵelementStart(37, "div", 26);
    i0.ɵɵelementStart(38, "div", 20);
    i0.ɵɵelementStart(39, "label", 21);
    i0.ɵɵtext(40, "Address Line 1");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(41, "input", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(42, "div", 9);
    i0.ɵɵelementStart(43, "div", 26);
    i0.ɵɵelementStart(44, "div", 20);
    i0.ɵɵelementStart(45, "label", 21);
    i0.ɵɵtext(46, "Address Line 2");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(47, "input", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(48, "div", 19);
    i0.ɵɵelementStart(49, "div", 20);
    i0.ɵɵelementStart(50, "label", 21);
    i0.ɵɵtext(51, " ZIP / Postalcode");
    i0.ɵɵtemplate(52, AddEducationDetailsComponent_ng_container_1_span_52_Template, 1, 0, "span", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(53, "input", 29);
    i0.ɵɵtemplate(54, AddEducationDetailsComponent_ng_container_1_span_54_Template, 2, 1, "span", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(55, "div", 9);
    i0.ɵɵelementStart(56, "div", 19);
    i0.ɵɵelementStart(57, "div", 20);
    i0.ɵɵelementStart(58, "label", 21);
    i0.ɵɵtext(59, "Country");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(60, "p-dropdown", 31);
    i0.ɵɵlistener("onChange", function AddEducationDetailsComponent_ng_container_1_Template_p_dropdown_onChange_60_listener() { i0.ɵɵrestoreView(_r47); const ctx_r48 = i0.ɵɵnextContext(); return ctx_r48.handleCountryChange(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(61, AddEducationDetailsComponent_ng_container_1_div_61_Template, 5, 1, "div", 32);
    i0.ɵɵtemplate(62, AddEducationDetailsComponent_ng_container_1_div_62_Template, 5, 0, "div", 32);
    i0.ɵɵelementStart(63, "div", 19);
    i0.ɵɵelementStart(64, "div", 20);
    i0.ɵɵelementStart(65, "label", 21);
    i0.ɵɵtext(66, "City");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(67, "input", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(68, "div", 9);
    i0.ɵɵelementStart(69, "div", 19);
    i0.ɵɵelementStart(70, "div", 20);
    i0.ɵɵelementStart(71, "label", 34);
    i0.ɵɵtext(72, "Start Year");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(73, "year-date-picker-library", 35);
    i0.ɵɵtemplate(74, AddEducationDetailsComponent_ng_container_1_div_74_Template, 2, 1, "div", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(75, AddEducationDetailsComponent_ng_container_1_div_75_Template, 6, 2, "div", 32);
    i0.ɵɵelementStart(76, "div", 19);
    i0.ɵɵelementStart(77, "div", 20);
    i0.ɵɵelementStart(78, "label", 34);
    i0.ɵɵtext(79, "Degree Awarded Date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(80, "mat-form-field", 36);
    i0.ɵɵelementStart(81, "input", 37);
    i0.ɵɵlistener("click", function AddEducationDetailsComponent_ng_container_1_Template_input_click_81_listener() { i0.ɵɵrestoreView(_r47); const _r14 = i0.ɵɵreference(84); return _r14.open(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(82, "mat-datepicker-toggle", 38);
    i0.ɵɵelement(83, "mat-datepicker", null, 39);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(85, AddEducationDetailsComponent_ng_container_1_div_85_Template, 2, 0, "div", 30);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(86, "div");
    i0.ɵɵelementStart(87, "div", 40);
    i0.ɵɵelementStart(88, "div", 41);
    i0.ɵɵtemplate(89, AddEducationDetailsComponent_ng_container_1_lib_save_as_draft_89_Template, 1, 2, "lib-save-as-draft", 42);
    i0.ɵɵelementStart(90, "button", 43);
    i0.ɵɵlistener("click", function AddEducationDetailsComponent_ng_container_1_Template_button_click_90_listener() { i0.ɵɵrestoreView(_r47); const ctx_r50 = i0.ɵɵnextContext(); return ctx_r50.saveDegreeDetails(); });
    i0.ɵɵtext(91, " Save ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(92, "hr");
    i0.ɵɵelementStart(93, "div", 44);
    i0.ɵɵelementStart(94, "div", 45);
    i0.ɵɵelementStart(95, "button", 46);
    i0.ɵɵtext(96, "Next");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(97, "div", 45);
    i0.ɵɵelementStart(98, "button", 47);
    i0.ɵɵlistener("click", function AddEducationDetailsComponent_ng_container_1_Template_button_click_98_listener() { i0.ɵɵrestoreView(_r47); const ctx_r51 = i0.ɵɵnextContext(); return ctx_r51.closeForm(); });
    i0.ɵɵtext(99, " Close ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(100, "div", 48);
    i0.ɵɵtext(101, " (Click on save button to save data) ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(102, "mat-step", 49);
    i0.ɵɵelementStart(103, "form", 15);
    i0.ɵɵtemplate(104, AddEducationDetailsComponent_ng_container_1_ng_template_104_Template, 1, 0, "ng-template", 16);
    i0.ɵɵelementStart(105, "div", 17);
    i0.ɵɵelementStart(106, "div", 9);
    i0.ɵɵelementStart(107, "label");
    i0.ɵɵtext(108, "List of Courses");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(109, "div", 9);
    i0.ɵɵelementStart(110, "div", 50);
    i0.ɵɵelementStart(111, "mat-form-field", 51);
    i0.ɵɵelementStart(112, "mat-chip-list", 52, 53);
    i0.ɵɵtemplate(114, AddEducationDetailsComponent_ng_container_1_mat_chip_114_Template, 3, 4, "mat-chip", 54);
    i0.ɵɵelementStart(115, "input", 55);
    i0.ɵɵlistener("paste", function AddEducationDetailsComponent_ng_container_1_Template_input_paste_115_listener($event) { i0.ɵɵrestoreView(_r47); const ctx_r52 = i0.ɵɵnextContext(); return ctx_r52.pasteChips($event); })("matChipInputTokenEnd", function AddEducationDetailsComponent_ng_container_1_Template_input_matChipInputTokenEnd_115_listener($event) { i0.ɵɵrestoreView(_r47); const ctx_r53 = i0.ɵɵnextContext(); return ctx_r53.add($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(116, "mat-hint", 56);
    i0.ɵɵtext(117, "Please enter comma separated values");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(118, "div", 57);
    i0.ɵɵelementStart(119, "button", 58);
    i0.ɵɵlistener("click", function AddEducationDetailsComponent_ng_container_1_Template_button_click_119_listener() { i0.ɵɵrestoreView(_r47); const ctx_r54 = i0.ɵɵnextContext(); return ctx_r54.addCourses(); });
    i0.ɵɵtext(120, " Add ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(121, AddEducationDetailsComponent_ng_container_1_div_121_Template, 6, 1, "div", 59);
    i0.ɵɵelement(122, "div", 60);
    i0.ɵɵelement(123, "hr");
    i0.ɵɵelementStart(124, "div", 9);
    i0.ɵɵelementStart(125, "div", 61);
    i0.ɵɵtemplate(126, AddEducationDetailsComponent_ng_container_1_button_126_Template, 2, 0, "button", 62);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(127, "div", 63);
    i0.ɵɵtemplate(128, AddEducationDetailsComponent_ng_container_1_button_128_Template, 2, 0, "button", 64);
    i0.ɵɵelementStart(129, "button", 65);
    i0.ɵɵtext(130, " Next ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(131, "mat-step");
    i0.ɵɵtemplate(132, AddEducationDetailsComponent_ng_container_1_ng_template_132_Template, 1, 0, "ng-template", 16);
    i0.ɵɵelementStart(133, "div", 17);
    i0.ɵɵelementStart(134, "div", 9);
    i0.ɵɵelementStart(135, "p");
    i0.ɵɵtext(136, " Select the related Degree documents and then click upload to save ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(137, "div", 9);
    i0.ɵɵelementStart(138, "div", 66);
    i0.ɵɵelementStart(139, "file-upload-deafult-library", 67);
    i0.ɵɵlistener("fileUploadSuccess", function AddEducationDetailsComponent_ng_container_1_Template_file_upload_deafult_library_fileUploadSuccess_139_listener() { i0.ɵɵrestoreView(_r47); const ctx_r55 = i0.ɵɵnextContext(); return ctx_r55.fileUploadSuccess(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(140, "div", 40);
    i0.ɵɵelement(141, "hr");
    i0.ɵɵelementStart(142, "div", 9);
    i0.ɵɵelementStart(143, "div", 19);
    i0.ɵɵelementStart(144, "button", 68);
    i0.ɵɵtext(145, "Back");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(146, AddEducationDetailsComponent_ng_container_1_div_146_Template, 3, 2, "div", 69);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r14 = i0.ɵɵreference(84);
    const _r18 = i0.ɵɵreference(113);
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("expanded", ctx_r0.expandPanel);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("linear", ctx_r0.isLinear);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("completed", ctx_r0.hasID);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroup", ctx_r0.addDegreeCourceForm);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(35, _c0, ctx_r0.isViewMode));
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("options", ctx_r0.degreeTypeList);
    i0.ɵɵadvance(33);
    i0.ɵɵproperty("ngIf", ctx_r0.iscountryUSA);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(37, _c1, ctx_r0.addDegreeCourceForm.get("postCode").touched && (ctx_r0.addDegreeCourceForm.get("postCode").errors == null ? null : ctx_r0.addDegreeCourceForm.get("postCode").errors.pattern)));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.addDegreeCourceForm.get("postCode").touched && (ctx_r0.addDegreeCourceForm.get("postCode").errors == null ? null : ctx_r0.addDegreeCourceForm.get("postCode").errors.required));
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("options", ctx_r0.listCountry);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.listStates.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.listStates.length <= 0);
    i0.ɵɵadvance(11);
    i0.ɵɵproperty("yearFormControl", ctx_r0.addDegreeCourceForm.controls.startYear);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.showStartYearValidationError);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.iscaseRequest ? ctx_r0.currentItemDisplay.includes("EDUDTLS") ? true : false : true);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("min", ctx_r0.endYearValue)("matDatepicker", _r14);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", _r14);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.showAwardedYearValidationError);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r0.beneficiaryType === "self");
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("disabled", !ctx_r0.hasID);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("stepControl", ctx_r0.addRelatedCourceForm);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroup", ctx_r0.addRelatedCourceForm);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(39, _c0, ctx_r0.isViewMode));
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("ngForOf", ctx_r0.courses);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matChipInputFor", _r18)("matChipInputSeparatorKeyCodes", ctx_r0.separatorKeysCodes);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("disabled", ctx_r0.courses && ctx_r0.courses.length === 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.listCourses && ctx_r0.listCourses.length > 0);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r0.iscaseRequest ? ctx_r0.currentItemDisplay.includes("DGRENAME") ? true : ctx_r0.currentItemDisplay.includes("EDUDTLS") ? true : ctx_r0.currentItemDisplay.includes("GRADE") ? true : ctx_r0.currentItemDisplay.includes("STUDYFIELD") ? true : ctx_r0.currentItemDisplay.includes("UNIVERSITYADR") ? true : ctx_r0.currentItemDisplay.includes("UNIVERSITYNAME") ? true : false : true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r0.modeVal);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(41, _c0, ctx_r0.isViewMode));
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("primaryData", ctx_r0.inputData)("configurations", ctx_r0.degreeFileUploadConfigurations);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngIf", !ctx_r0.viewMode);
} }
function AddEducationDetailsComponent_ng_container_8_th_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 93);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r56 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", column_r56.header, " ");
} }
function AddEducationDetailsComponent_ng_container_8_td_2_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 97);
    i0.ɵɵelementStart(1, "mat-icon", 98);
    i0.ɵɵtext(2, "expand_more");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function AddEducationDetailsComponent_ng_container_8_td_2_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r65 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 99);
    i0.ɵɵelementStart(1, "mat-icon", 100);
    i0.ɵɵlistener("click", function AddEducationDetailsComponent_ng_container_8_td_2_div_4_Template_mat_icon_click_1_listener() { i0.ɵɵrestoreView(_r65); const element_r60 = i0.ɵɵnextContext().$implicit; const ctx_r63 = i0.ɵɵnextContext(2); return ctx_r63.editDegreeHandler(element_r60); });
    i0.ɵɵtext(2, "edit");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-icon", 101);
    i0.ɵɵlistener("click", function AddEducationDetailsComponent_ng_container_8_td_2_div_4_Template_mat_icon_click_3_listener() { i0.ɵɵrestoreView(_r65); const element_r60 = i0.ɵɵnextContext().$implicit; const ctx_r66 = i0.ɵɵnextContext(2); return ctx_r66.handleDelete(element_r60, ctx_r66.addDegreeCourceForm); });
    i0.ɵɵtext(4, " delete_forever");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function AddEducationDetailsComponent_ng_container_8_td_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 94);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, AddEducationDetailsComponent_ng_container_8_td_2_span_2_Template, 3, 0, "span", 95);
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵtemplate(4, AddEducationDetailsComponent_ng_container_8_td_2_div_4_Template, 5, 0, "div", 96);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r60 = ctx.$implicit;
    const column_r56 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", column_r56.columnDef == "degreeType" ? element_r60 == null ? null : element_r60.degreeType == null ? null : element_r60.degreeType.description : element_r60[column_r56.columnDef], " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r56.columnDef == "toggle");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", column_r56.columnDef == "action");
} }
function AddEducationDetailsComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 91);
    i0.ɵɵtemplate(1, AddEducationDetailsComponent_ng_container_8_th_1_Template, 2, 1, "th", 92);
    i0.ɵɵtemplate(2, AddEducationDetailsComponent_ng_container_8_td_2_Template, 5, 3, "td", 5);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r56 = ctx.$implicit;
    i0.ɵɵpropertyInterpolate("matColumnDef", column_r56.columnDef);
} }
function AddEducationDetailsComponent_td_10_div_2_tr_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 107);
    i0.ɵɵelementStart(1, "td", 81);
    i0.ɵɵelementStart(2, "div", 82);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td", 108);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r73 = ctx.$implicit;
    const i_r74 = ctx.index;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i_r74 + 1, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r73.courseName, " ");
} }
function AddEducationDetailsComponent_td_10_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 104);
    i0.ɵɵelementStart(1, "h6");
    i0.ɵɵtext(2, "List of Courses");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(3);
    i0.ɵɵelementStart(4, "table", 105);
    i0.ɵɵtemplate(5, AddEducationDetailsComponent_td_10_div_2_tr_5_Template, 6, 2, "tr", 106);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r69 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", element_r69.courses);
} }
function AddEducationDetailsComponent_td_10_div_3_tr_15_Template(rf, ctx) { if (rf & 1) {
    const _r80 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 81);
    i0.ɵɵelementStart(2, "div", 82);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "td");
    i0.ɵɵelementStart(5, "strong");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td", 108);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td", 108);
    i0.ɵɵelementStart(10, "button", 112);
    i0.ɵɵlistener("click", function AddEducationDetailsComponent_td_10_div_3_tr_15_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r80); const item_r77 = ctx.$implicit; const ctx_r79 = i0.ɵɵnextContext(3); return ctx_r79.downloadDoc(item_r77); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r77 = ctx.$implicit;
    const i_r78 = ctx.index;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i_r78 + 1, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(item_r77 == null ? null : item_r77.fileName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", (item_r77 == null ? null : item_r77.fileCategory == null ? null : item_r77.fileCategory.code) === "OTHER" ? item_r77 == null ? null : item_r77.fileCategoryOtherName : item_r77 == null ? null : item_r77.fileCategory == null ? null : item_r77.fileCategory.name, " ");
} }
function AddEducationDetailsComponent_td_10_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 104);
    i0.ɵɵelementStart(1, "h6");
    i0.ɵɵtext(2, "List of Documents");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerStart(3);
    i0.ɵɵelementStart(4, "table", 109);
    i0.ɵɵelementStart(5, "thead");
    i0.ɵɵelementStart(6, "tr");
    i0.ɵɵelement(7, "th", 81);
    i0.ɵɵelementStart(8, "th");
    i0.ɵɵtext(9, "Document");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "th");
    i0.ɵɵtext(11, "Document Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "th");
    i0.ɵɵelement(13, "i", 110);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "tbody");
    i0.ɵɵtemplate(15, AddEducationDetailsComponent_td_10_div_3_tr_15_Template, 11, 3, "tr", 111);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r69 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(15);
    i0.ɵɵproperty("ngForOf", element_r69.documents);
} }
function AddEducationDetailsComponent_td_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 94);
    i0.ɵɵelementStart(1, "div", 102);
    i0.ɵɵtemplate(2, AddEducationDetailsComponent_td_10_div_2_Template, 6, 1, "div", 103);
    i0.ɵɵtemplate(3, AddEducationDetailsComponent_td_10_div_3_Template, 16, 1, "div", 103);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r69 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵattribute("colspan", ctx_r2.columns.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("@detailExpand", element_r69 == ctx_r2.expandedElement ? "expanded" : "collapsed");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", element_r69 && element_r69.courses && element_r69.courses.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", element_r69 && element_r69.documents && element_r69.documents.length > 0);
} }
function AddEducationDetailsComponent_tr_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 113);
} }
function AddEducationDetailsComponent_tr_12_Template(rf, ctx) { if (rf & 1) {
    const _r84 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 114);
    i0.ɵɵlistener("click", function AddEducationDetailsComponent_tr_12_Template_tr_click_0_listener() { i0.ɵɵrestoreView(_r84); const element_r82 = ctx.$implicit; const ctx_r83 = i0.ɵɵnextContext(); return ctx_r83.expandedElement = ctx_r83.expandedElement === element_r82 ? null : element_r82; });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const element_r82 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("example-expanded-row", ctx_r4.expandedElement === element_r82);
} }
function AddEducationDetailsComponent_tr_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 115);
} }
const _c2 = function () { return ["expandedDetail"]; };
const DeleteDialogConfigurations = {
    width: '50%',
    closeOnEscape: false,
    closable: false,
    showHeader: false,
    contentStyle: { "z-index": "1001" }
};
class AddEducationDetailsComponent {
    constructor(cacheCountryService, apiService, toastr, changeDetectorRef, referenceLibraryService, fb, route, dialog, store, dynamicDialogConfig, dialogService
    // private benServ: BeneficiaryQuestionnaireService
    ) {
        var _a, _b, _c, _d;
        this.cacheCountryService = cacheCountryService;
        this.apiService = apiService;
        this.toastr = toastr;
        this.changeDetectorRef = changeDetectorRef;
        this.referenceLibraryService = referenceLibraryService;
        this.fb = fb;
        this.route = route;
        this.dialog = dialog;
        this.store = store;
        this.dynamicDialogConfig = dynamicDialogConfig;
        this.dialogService = dialogService;
        this.modeVal = false;
        this.showEditButton = false;
        this.submitted = false;
        this.updateBenProfile = true;
        this.listCourses = [];
        this.educationDetailsList = [];
        // auto chips
        this.visible = true;
        this.selectable = true;
        this.removable = true;
        this.addOnBlur = true;
        this.separatorKeysCodes = [ENTER, COMMA];
        this.courses = [];
        this.documentTypes = [];
        this.setYearValue = '2010';
        this.showEndYearValidationError = false;
        this.showStartYearValidationError = false;
        this.showAwardedYearValidationError = false;
        this.formSubmittd = false;
        this.viewMode = false;
        this.degreeFileUploadConfigurations = {
            inputMultipleFlag: true,
            fileType: acceptedFileTypes,
            isFileListRequired: true,
            categoryName: 'BENEDUDOC',
            entityId: 0,
            fileCategory: '',
            listUploadedFiles: [],
            documentTypeRequired: true,
            docummentTypeCode: 'BENEDUDOC',
            useCase: 'beneficiary',
            useCaseId: 0,
            useEntityId: false,
            familyId: null,
        };
        this.expandPanel = true;
        this.isListView = false;
        this.isTimeLineView = true;
        this.hasID = false;
        this.isLinear = true;
        this.iscountryUSA = false;
        this.destroy$ = new Subject();
        this.observableSubscription$ = new Subject();
        this.isSaveAsDraftDisabled = true;
        this.isLocked = false;
        this.currentItemDisplay = [];
        this.iscaseRequest = false;
        ///////////////// --------------------------------------------------------- LISTING CODE START ---------------------------------------------------//
        this.educationList = [];
        this.educationDetails = [];
        this.displayedColumns = [];
        this.enableEdit = new EventEmitter();
        this.removeElement = new EventEmitter();
        this.columns = [
            { columnDef: 'toggle', header: '', columnType: 'icon', customClass: '' },
            { columnDef: 'degreeType', header: 'Degree', columnType: 'text', customClass: '' },
            { columnDef: 'fieldOfStudy', header: 'Field Of Study', columnType: 'text', customClass: '' },
            { columnDef: 'startYear', header: 'Start Year', columnType: 'text', customClass: '' },
            { columnDef: 'endYear', header: 'End Year', columnType: 'text', customClass: '' },
            { columnDef: 'grade', header: 'Grade', columnType: 'text', customClass: '' },
            { columnDef: 'university', header: 'University', columnType: 'text', customClass: '' },
            { columnDef: 'action', header: 'Action', columnType: 'icon', customClass: '' }
        ];
        ///////////////// --------------------------------------------------------- LISTING CODE END ---------------------------------------------------//
        this.showDegreeAwardedDateRequired = true;
        this.referenceLibraryService.getReferenceDataWithoutAuthentication('DEGR').pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            this.degreeTypeList = response;
        });
        this.cacheCountryService.getCountry().pipe(takeUntil(this.observableSubscription$)).subscribe(data => {
            if (data.length > 0) {
                this.listCountry = [{ countryCode: '', countryName: 'Select', phoneCode: '' }, ...data];
            }
        });
        // this.referenceLibraryService.getReferenceData('BENEDUDOC').pipe(takeUntil(this.observableSubscription$))..subscribe((response: ReferenceLibrary[]) => {
        //   this.documentTypes = response;
        // });
        this.addDegreeCourceForm = this.fb.group({
            id: [],
            degree: [''],
            degreeType: ['', Validators.required],
            fieldOfStudy: ['', Validators.required],
            grade: [''],
            universityName: ['', Validators.required],
            addressLine1: ['', Validators.required],
            addressLine2: [''],
            postCode: [''],
            countryCode: ['', Validators.required],
            stateProvinceCode: [null],
            stateProvinceName: [''],
            city: ['', Validators.required],
            startYear: ['', Validators.required],
            endYear: ['', Validators.required],
            degreeAwardedDate: ['']
        });
        this.addRelatedCourceForm = this.fb.group({});
        this.listCountry = [];
        this.listStates = [];
        this.formChangesSubscriptions = [];
        this.inputData = {
            visaType: 'H1B',
            caseType: 'PETITION',
            caseId: JSON.parse(sessionStorage.getItem('tempPetitionId')),
            superTaskId: (_b = (_a = this.dynamicDialogConfig.data) === null || _a === void 0 ? void 0 : _a.superTaskId) !== null && _b !== void 0 ? _b : null,
            subTaskId: (_d = (_c = this.dynamicDialogConfig.data) === null || _c === void 0 ? void 0 : _c.subTaskId) !== null && _d !== void 0 ? _d : null
        };
    }
    ngOnInit() {
        this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
        this.onlyFormBuilder = this.route.snapshot.queryParams.pageFrom;
        this.beneficiaryId = sessionStorage.getItem('beneficiaryId') ? parseInt(sessionStorage.getItem('beneficiaryId')) : 0;
        this.modeVal = true;
        this.viewMode = sessionStorage.getItem('bene-profile-viewMode') == 'true' ? true : false;
        this.expandPanel = true;
        this.hasID = false;
        this.isLinear = true;
        this.afterLoadingNgInit();
        this.formStatusCheck();
        this.getDegreeDetails();
    }
    downloadDoc(doc) {
        this.apiService.downloadDocuments(environment.docs + doc.fileLocation.substring(23), doc.fileLocation.substring(23));
    }
    formStatusCheck() {
        this.formChangesSubscriptions[0] = this.addDegreeCourceForm.valueChanges.pipe(map(() => this.addDegreeCourceForm.dirty && this.addDegreeCourceForm.enabled), distinctUntilChanged(), takeUntil(this.destroy$)).subscribe(dirty => {
            if (dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true,
                    message: 'If you leave before saving, all changes made on the \'Education\' form will be lost. Do you wish to continue?'
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false,
                    message: ''
                }));
            }
        });
        this.formChangesSubscriptions[1] = this.addRelatedCourceForm.valueChanges.pipe(map(() => this.addRelatedCourceForm.dirty && this.addRelatedCourceForm.enabled), distinctUntilChanged(), takeUntil(this.destroy$)).subscribe(dirty => {
            if (dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true,
                    message: 'If you leave before saving, all changes made on the \'Related Course\' form will be lost. Do you wish to continue?'
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false,
                    message: ''
                }));
            }
        });
    }
    afterLoadingNgInit() {
        if (this.route.snapshot.paramMap.get('listview')) {
            this.toggleListView(true);
        }
        if (this.beneficiaryId) {
            this.degreeFileUploadConfigurations.useCaseId = this.beneficiaryId;
            this.degreeFileUploadConfigurations.familyId = this.familyId;
            this.degreeFileUploadConfigurations = Object.assign({}, this.degreeFileUploadConfigurations);
            this.getUpolodedFiles();
        }
        this.cacheCountryService.getCachedCountryList().pipe(takeUntil(this.observableSubscription$)).subscribe(data => {
            if (data.listCountries.length > 0) {
                this.listCountry = data.listCountries;
            }
        });
        this.apiService.deletedfile$.pipe(takeUntil(this.observableSubscription$)).subscribe(status => {
            if (status === true) {
                this.getDegreeDetails();
            }
        });
        this.addDegreeCourceForm.controls['endYear'].valueChanges.pipe(takeUntil(this.observableSubscription$)).subscribe(change => {
            this.degreeAwardedDateValidator();
        });
        this.addDegreeCourceForm.controls['startYear'].valueChanges.pipe(takeUntil(this.observableSubscription$)).subscribe(change => {
            this.degreeAwardedDateValidator();
        });
        // IM-3493 - System accepting Degree awarded date lesser than education end year
        this.addDegreeCourceForm.controls['degreeAwardedDate'].valueChanges.pipe(takeUntil(this.observableSubscription$)).subscribe(val => {
            this.showAwardedYearValidationError = false;
            if (this.addDegreeCourceForm.get('endYear').value && moment(this.addDegreeCourceForm.get('endYear').value).format('YYYY') > moment(val).format('YYYY')) {
                this.showAwardedYearValidationError = true;
            }
        });
        if (localStorage.getItem('currentUserSelection')) {
            this.selectedUser = JSON.parse(localStorage.getItem('currentUserSelection'));
        }
        if (localStorage.getItem('customQuestions')) {
            this.customQuestions = JSON.parse(localStorage.getItem('customQuestions'));
        }
    }
    handleCountryChange() {
        const countryCode = this.addDegreeCourceForm.get('countryCode').value;
        this.apiService.getStates(countryCode).pipe(takeUntil(this.observableSubscription$)).subscribe((states) => {
            this.listStates = states;
            this.changeDetectorRef.markForCheck();
            this.addDegreeCourceForm.get('stateProvinceName').clearValidators();
            this.addDegreeCourceForm.get('stateProvinceCode').clearValidators();
            if (states.length > 0) {
                this.addDegreeCourceForm.get('stateProvinceCode').setValidators([Validators.required]);
            }
            else {
                this.addDegreeCourceForm.get('stateProvinceName').setValidators([Validators.required]);
            }
            this.addDegreeCourceForm.get('stateProvinceName').updateValueAndValidity();
            this.addDegreeCourceForm.get('stateProvinceCode').updateValueAndValidity();
            if (this.iscaseRequest) {
                this.addDegreeCourceForm.get('stateProvinceName').clearValidators();
                this.addDegreeCourceForm.get('stateProvinceCode').clearValidators();
                this.addDegreeCourceForm.get('stateProvinceName').updateValueAndValidity();
                this.addDegreeCourceForm.get('stateProvinceCode').updateValueAndValidity();
            }
        });
        if (countryCode === 'USA') {
            this.iscountryUSA = true;
            this.addDegreeCourceForm.get('postCode').setValidators([Validators.required, Validators.pattern(/^[a-z0-9]+$/)]);
        }
        else {
            this.iscountryUSA = false;
            this.addDegreeCourceForm.get('postCode').clearValidators();
            this.addDegreeCourceForm.get('postCode').setValidators([Validators.pattern(/^[a-z0-9]+$/)]);
        }
        this.addDegreeCourceForm.get('postCode').updateValueAndValidity();
        if (this.iscaseRequest) {
            this.addDegreeCourceForm.get('postCode').clearValidators();
            this.addDegreeCourceForm.get('postCode').setValidators([Validators.pattern(/^[a-z0-9]+$/)]);
            this.addDegreeCourceForm.get('postCode').updateValueAndValidity();
        }
        this.degreeAwardedDateValidator();
    }
    addCourses() {
        this.listCourses = this.listCourses.concat(this.courses);
        this.saveDegreeDetails();
    }
    deleteEducation(index) {
        const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, DeleteDialogConfigurations);
        deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                if (index !== -1) {
                    this.listCourses.splice(index, 1);
                }
                this.saveDegreeDetails();
            }
        });
    }
    getDegreeDetails() {
        // let petitionId = JSON.parse(sessionStorage.getItem('tempPetitionId'));
        this.apiService.getEducationDetails(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, sync_profile_code.SYNC_TASK_TYPE_EDUCATION, this.inputData.superTaskId, this.inputData.subTaskId)
            .pipe(take(1))
            .subscribe(data => {
            if (data['status'] === 200) {
                this.educationDetailsList = data['data'];
                if (this.educationDetailsList) {
                    this.educationDetails = this.educationDetailsList;
                    this.educationDetails = this.educationDetails.map(e1 => {
                        let _e1 = Object.assign({}, e1);
                        if (_e1.documents) {
                            _e1.documents = _e1.documents.map(e2 => {
                                let _e2 = Object.assign({}, e2);
                                if (_e2.fileLocation) {
                                    _e2.fileLocationName = _e2.fileLocation.substring(23);
                                    this.courses = [];
                                    this.addDegreeCourceForm.controls['id'].setValue(_e1.id);
                                    return _e2;
                                }
                            });
                        }
                        else {
                            this.degreeFileUploadConfigurations.listUploadedFiles = [];
                        }
                        return _e1;
                    });
                    this.dataSource = new MatTableDataSource(this.educationDetails);
                }
            }
            if (data['status'] === 204) {
                this.educationDetailsList = [];
                this.educationDetails = [];
                this.dataSource = new MatTableDataSource([]);
            }
        });
    }
    saveDegreeDetails(isDraft = false) {
        this.educationDegreeDetails = this.addDegreeCourceForm.value;
        this.createPayload(this.addDegreeCourceForm.value, isDraft);
        this.addDegreeCourceForm.reset(this.addDegreeCourceForm.value);
    }
    createPayload(degreeInfo, isDraft = false) {
        const reqObj = {
            isSaveAsDraft: isDraft,
            id: this.eduId || 0,
            country: degreeInfo && degreeInfo.countryCode ? { countryCode: degreeInfo.countryCode } : null,
            university: degreeInfo.universityName ? degreeInfo.universityName : '',
            degree: degreeInfo.degree ? degreeInfo.degree : '',
            grade: degreeInfo.grade ? degreeInfo.grade : '',
            equivalance: degreeInfo.equivalance ? degreeInfo.equivalance : '',
            fieldOfStudy: degreeInfo.fieldOfStudy ? degreeInfo.fieldOfStudy : '',
            startYear: degreeInfo.startYear ? moment(degreeInfo.startYear).year().toString() : '',
            endYear: degreeInfo.endYear ? moment(degreeInfo.endYear).year().toString() : '',
            degreeAwardedDate: degreeInfo.degreeAwardedDate ? moment(degreeInfo.degreeAwardedDate).format('YYYY-MM-DD') : '',
            addressLine1: degreeInfo.addressLine1 ? degreeInfo.addressLine1 : '',
            addressLine2: degreeInfo.addressLine2 ? degreeInfo.addressLine2 : '',
            stateProvinceCode: degreeInfo.stateProvinceCode ? degreeInfo.stateProvinceCode : null,
            stateProvinceName: degreeInfo.stateProvinceName ? degreeInfo.stateProvinceName : '',
            postCode: degreeInfo.postCode ? degreeInfo.postCode : '',
            city: degreeInfo.city ? degreeInfo.city : '',
            degreeType: degreeInfo && degreeInfo.degreeType ? { id: degreeInfo.degreeType } : null,
            courses: this.listCourses
        };
        const reqPayload = { education: [reqObj] };
        let petitionId = JSON.parse(sessionStorage.getItem('tempPetitionId'));
        this.apiService.saveEducatinDegreeDetails(petitionId, reqPayload, this.familyId).pipe(takeUntil(this.observableSubscription$)).subscribe(response => {
            if (response.status === 200) {
                this.toastr.success(response.message, 'Success');
                this.degreeFileUploadConfigurations.entityId = response.data.id;
                this.degreeFileUploadConfigurations = Object.assign({}, this.degreeFileUploadConfigurations);
                this.listCourses = response.data.courses;
                this.courses = [];
                this.eduId = response.data.id;
                // this.addDegreeCourceForm.controls['id'].patchValue(response.data.id);\
                this.hasID = true;
                this.isLinear = false;
                this.degreeFileUploadConfigurations.useCaseId = this.beneficiaryId;
                // this.resetForm();       
                this.getDegreeDetails();
            }
            else {
                CustomErrorToastComponent.showErrorToast(this.toastr, response.message);
            }
        });
    }
    editDegreeHandler(eduDegree) {
        this.expandPanel = true;
        this.eduId = eduDegree.id;
        this.addDegreeCourceForm.setValue({
            id: eduDegree.id ? eduDegree.id : 0,
            degree: eduDegree.degree ? eduDegree.degree : '',
            degreeType: eduDegree && eduDegree.degreeType ? eduDegree.degreeType.id : null,
            fieldOfStudy: eduDegree.fieldOfStudy,
            grade: eduDegree.grade ? eduDegree.grade : '',
            universityName: eduDegree.university,
            addressLine1: eduDegree.addressLine1,
            addressLine2: eduDegree.addressLine2,
            postCode: eduDegree.postCode ? eduDegree.postCode : '',
            countryCode: eduDegree.country ? eduDegree.country.countryCode : null,
            stateProvinceCode: eduDegree.stateProvinceCode ? eduDegree.stateProvinceCode : null,
            stateProvinceName: eduDegree.stateProvinceName,
            city: eduDegree.city,
            startYear: eduDegree.startYear ? moment([eduDegree.startYear, 0, 1]) : '',
            endYear: eduDegree.endYear ? moment([eduDegree.endYear, 0, 1]) : '',
            degreeAwardedDate: eduDegree.degreeAwardedDate ? moment(eduDegree.degreeAwardedDate).toISOString() : ''
        });
        this.handleCountryChange();
        this.listCourses = eduDegree.courses ? eduDegree.courses : [];
        if (eduDegree.id) {
            this.degreeFileUploadConfigurations.listUploadedFiles = eduDegree.documents;
            this.degreeFileUploadConfigurations.useCaseId = this.beneficiaryId;
            this.degreeFileUploadConfigurations.entityId = eduDegree.id;
            this.degreeFileUploadConfigurations = Object.assign({}, this.degreeFileUploadConfigurations);
            this.hasID = true;
            this.isLinear = false;
        }
    }
    add(event) {
        const input = event.input;
        const value = event.value;
        // Add our fruit
        if ((value || '').trim()) {
            this.courses.push({
                courseName: value.trim(),
                courseId: ''
            });
        }
        // Reset the input value
        if (input) {
            input.value = '';
        }
    }
    pasteChips(event) {
        event.preventDefault(); // Prevents the default action
        event.clipboardData
            .getData('Text') // Gets the text pasted
            .split(/,/) // Splits it when a SEMICOLON or COMMA or NEWLINE
            .forEach(value => {
            if (value.trim()) {
                this.courses.push({
                    courseName: value.trim(),
                    courseId: ''
                }); // Push if valid
            }
        });
    }
    remove(fruit) {
        const index = this.courses.indexOf(fruit);
        if (index >= 0) {
            this.courses.splice(index, 1);
        }
    }
    // dynamically adding validator for degreeAwardedDate
    degreeAwardedDateValidator() {
        const countryCode = this.addDegreeCourceForm.get('countryCode').value;
        const degreeAwardedDateControl = this.addDegreeCourceForm.get('degreeAwardedDate');
        // const endYearControl = this.addDegreeCourceForm.get('endYear');
        let endYear;
        let startYear;
        if (this.addDegreeCourceForm.get('startYear').value) {
            startYear = (this.addDegreeCourceForm.get('startYear').value).year();
        }
        if (this.addDegreeCourceForm.get('endYear').value) {
            this.endYearValue = moment(this.addDegreeCourceForm.get('endYear').value).format('YYYY-MM-DD');
            endYear = (this.addDegreeCourceForm.get('endYear').value).year();
        }
        const currentYear = moment().year();
        if (endYear && countryCode) {
            if (countryCode !== 'USA' && (endYear < currentYear)) {
                this.showDegreeAwardedDateRequired = true;
                degreeAwardedDateControl.setValidators(Validators.required);
            }
            else {
                this.showDegreeAwardedDateRequired = false;
                degreeAwardedDateControl.clearValidators();
            }
        }
        if (startYear && endYear) {
            // IM-3850 -Education -> End year same as start year to be allowed
            if (endYear >= startYear) {
                this.showEndYearValidationError = false;
            }
            else {
                this.showEndYearValidationError = true;
            }
        }
        if (startYear) {
            if (startYear > (new Date()).getFullYear()) {
                this.showStartYearValidationError = true;
            }
            else {
                this.showStartYearValidationError = false;
            }
        }
        degreeAwardedDateControl.updateValueAndValidity();
    }
    toggleExpansion() {
        this.expandPanel = !this.expandPanel;
        if (this.expandPanel) {
            this.resetForm();
            this.hasID = false;
            this.isLinear = true;
        }
    }
    addNewDegree() {
        this.resetForm();
        this.hasID = false;
        this.isLinear = true;
    }
    resetForm() {
        // this.addDegreeCourceForm.clearValidators();
        // this.addDegreeCourceForm.updateValueAndValidity();
        this.addDegreeCourceForm.reset();
        // validators required for both new and edit form
        this.formSubmittd = true;
        this.listCourses = [];
        this.degreeFileUploadConfigurations.listUploadedFiles = [];
        this.degreeFileUploadConfigurations.useCaseId = 0;
        this.degreeFileUploadConfigurations.entityId = 0;
        this.degreeFileUploadConfigurations = Object.assign({}, this.degreeFileUploadConfigurations);
        this.showEndYearValidationError = false;
        this.showStartYearValidationError = false;
    }
    closeForm() {
        this.toggleExpansion();
        this.addDegreeCourceForm.reset();
    }
    fileUploadSuccess() {
        this.getDegreeDetails();
    }
    toggleListView(val) {
        if (!val) {
            this.isTimeLineView = true;
            this.isListView = false;
        }
        else {
            this.isTimeLineView = false;
            this.isListView = true;
        }
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    onRefreshPage(event) {
        if (event) {
            this.ngOnInit();
        }
    }
    ngOnChanges(changes) {
        var _a, _b, _c, _d, _e, _f;
        if (changes.editEduData.currentValue) {
            this.inputData = changes.editEduData.currentValue;
            const inputData = Object.assign(Object.assign({}, changes.editEduData.currentValue), { superTaskId: (_c = (_a = changes.editEduData.currentValue.superTaskId) !== null && _a !== void 0 ? _a : (_b = this.inputData) === null || _b === void 0 ? void 0 : _b.superTaskId) !== null && _c !== void 0 ? _c : null, subTaskId: (_f = (_d = changes.editEduData.currentValue.subTaskId) !== null && _d !== void 0 ? _d : (_e = this.inputData) === null || _e === void 0 ? void 0 : _e.subTaskId) !== null && _f !== void 0 ? _f : null });
            this.inputData = Object.assign({}, inputData);
            this.getDegreeDetails();
        }
    }
    formValidation() {
        this.addDegreeCourceForm = this.fb.group({
            id: [],
            degree: [''],
            degreeType: [''],
            fieldOfStudy: [''],
            grade: [''],
            universityName: [''],
            addressLine1: [''],
            addressLine2: [''],
            postCode: [''],
            countryCode: [''],
            stateProvinceCode: [null],
            stateProvinceName: [''],
            city: [''],
            startYear: [''],
            endYear: [''],
            degreeAwardedDate: ['']
        });
    }
    ngAfterViewInit() {
        if (this.modeVal) {
            this.showFileUploadSection = true;
            this.toggleListView(true);
            this.toggleExpansion();
        }
    }
    ngOnDestroy() {
        this.addDegreeCourceForm.get('startYear').clearValidators();
        this.addDegreeCourceForm.get('endYear').clearValidators();
        this.addDegreeCourceForm.get('startYear').updateValueAndValidity();
        this.addDegreeCourceForm.get('endYear').updateValueAndValidity();
        if (this.formChangesSubscriptions.length > 0) {
            this.formChangesSubscriptions.forEach(element => {
                element.unsubscribe();
            });
        }
        if (this.dependentIdSubscription) {
            this.dependentIdSubscription.unsubscribe();
        }
        this.destroy$.next();
        this.destroy$.complete();
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
    }
    saveAsDraft(event) {
        this.saveDegreeDetails(event);
    }
    // ----------------------------------------------- LIST VIEW CODE START -----------------------------------------------//
    ngAfterContentInit() {
        this.displayedColumns = this.columns.map(c => c.columnDef);
    }
    handleEdit(educationElement) {
        this.enableEdit.emit(educationElement);
    }
    handleDelete(input, addDegreeCourceForm) {
        const deleteDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, DeleteDialogConfigurations);
        deleteDialogRef.onClose.pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response) {
                let petitionId = JSON.parse(sessionStorage.getItem('tempPetitionId'));
                this.apiService.deleteEducatinDegreeDetails(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, sync_profile_code.SYNC_TASK_TYPE_EDUCATION, this.inputData.superTaskId, this.inputData.subTaskId, input.id).pipe(takeUntil(this.observableSubscription$)).subscribe(data => {
                    if (this.addDegreeCourceForm.get('id').value === input.id) {
                        this.resetForm();
                    }
                    this.toastr.success("Data deleted successfully!", 'Success');
                    this.getDegreeDetails();
                });
            }
        });
    }
    getUpolodedFiles() {
        this.apiService.genericGetUploadDocument(this.degreeFileUploadConfigurations.useCase, this.degreeFileUploadConfigurations.useCaseId, this.degreeFileUploadConfigurations.categoryName, this.degreeFileUploadConfigurations.entityId, this.degreeFileUploadConfigurations.useEntityId, this.degreeFileUploadConfigurations.familyId).pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            if (response['status'] === 200) {
                this.listUploadedFiles = response['data'];
                // this.degreeFileUploadConfigurations.listUploadedFiles = response['data'];
                this.degreeFileUploadConfigurations = Object.assign({}, this.degreeFileUploadConfigurations);
            }
            else {
                this.listUploadedFiles = [];
                this.degreeFileUploadConfigurations.listUploadedFiles = [];
            }
        });
    }
}
AddEducationDetailsComponent.ɵfac = function AddEducationDetailsComponent_Factory(t) { return new (t || AddEducationDetailsComponent)(i0.ɵɵdirectiveInject(i1$1.CacheCountryListService), i0.ɵɵdirectiveInject(AddEducationDetailsService), i0.ɵɵdirectiveInject(i3.ToastrService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i4.ReferenceLibraryService), i0.ɵɵdirectiveInject(i5.FormBuilder), i0.ɵɵdirectiveInject(i6.ActivatedRoute), i0.ɵɵdirectiveInject(i7.MatDialog), i0.ɵɵdirectiveInject(i8.Store), i0.ɵɵdirectiveInject(i9.DynamicDialogConfig), i0.ɵɵdirectiveInject(i9.DialogService)); };
AddEducationDetailsComponent.ɵcmp = i0.ɵɵdefineComponent({ type: AddEducationDetailsComponent, selectors: [["add-education-details"]], viewQuery: function AddEducationDetailsComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(MatPaginator, 3);
        i0.ɵɵviewQuery(MatSort, 3);
        i0.ɵɵviewQuery(MatAccordion, 1);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.paginator = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sort = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.accordion = _t);
    } }, inputs: { editEduData: "editEduData", mode: "mode", showFileUploadSection: "showFileUploadSection", isViewMode: "isViewMode", caseRequestShowDivs: "caseRequestShowDivs", educationList: "educationList" }, outputs: { enableEdit: "enableEdit", removeElement: "removeElement" }, features: [i0.ɵɵNgOnChangesFeature], decls: 14, vars: 8, consts: [[4, "ngIf"], [1, "p-3"], ["mat-table", "", "multiTemplateDataRows", "", 1, "im-card-no-border-table", 3, "dataSource"], [3, "matColumnDef", 4, "ngFor", "ngForOf"], ["matColumnDef", "expandedDetail"], ["mat-cell", "", 4, "matCellDef"], ["mat-header-row", "", 4, "matHeaderRowDef"], ["mat-row", "", "class", "example-element-row", 3, "example-expanded-row", "click", 4, "matRowDef", "matRowDefColumns"], ["mat-row", "", "class", "example-detail-row", 4, "matRowDef", "matRowDefColumns"], [1, "row"], ["type", "button", 1, "btn", "btn-primary", "mb-2", 3, "click"], ["hideToggle", "", 3, "expanded"], ["labelPosition", "bottom", 1, "pb-mat-stepper-custom-horizontal", 3, "linear"], ["stepper", ""], [3, "completed"], [3, "formGroup"], ["matStepLabel", ""], [1, "formBox", 3, "ngClass"], [1, "row", "paddingTop10"], [1, "col-4"], [1, "form-group"], [1, "label-cls"], ["formControlName", "degreeType", "optionLabel", "name", "optionValue", "id", "placeholder", "Select Degree", 1, "w-100", 3, "options"], ["formControlName", "fieldOfStudy", "type", "text", "form", "", "placeholder", "Enter", 1, "im-input", "mw-100"], ["type", "text", "name", "grade", "formControlName", "grade", "placeholder", "Enter", 1, "im-input", "mw-100"], ["formControlName", "universityName", "type", "text", "form", "", "placeholder", "Enter", 1, "im-input", "mw-100"], [1, "col-8"], ["maxlength", "99", "formControlName", "addressLine1", "type", "text", "form", "", "placeholder", "Enter", 1, "im-input", "mw-100"], ["maxlength", "99", "formControlName", "addressLine2", "type", "text", "form", "", "placeholder", "Enter", 1, "im-input", "mw-100"], ["formControlName", "postCode", "type", "text", "form", "", "placeholder", "Enter", "maxlength", "10", 1, "im-input", "mw-100", 3, "ngClass"], ["class", "invalid-message", 4, "ngIf"], ["formControlName", "countryCode", "optionLabel", "countryName", "optionValue", "countryCode", "placeholder", "Select Country", 1, "w-100", 3, "options", "onChange"], ["class", "col-4", 4, "ngIf"], ["formControlName", "city", "type", "text", "form", "", "placeholder", "Enter", 1, "im-input", "mw-100"], [1, "label-cls", "d-block"], [3, "yearFormControl"], ["appearance", "outline", 1, "mt-0", "date-field", "w-100"], ["formControlName", "degreeAwardedDate", "matInput", "", "placeholder", "MM/DD/YYYY", 3, "min", "matDatepicker", "click"], ["matSuffix", "", 3, "for"], ["degreeAwardedDate", ""], [1, "row", "paddingTop10", "dasheedTopBorder"], [1, "form-group", "col-md-6"], ["confirmModelKey", "savedraftdegree", "class", "mr-3", 3, "disabled", "formToBeSaved", "onClickSaveAsDraft", 4, "ngIf"], [1, "btn", "btn-success", 3, "click"], [1, "d-flex", "flex-row-reverse"], [1, "p-2"], ["matStepperNext", "", 1, "btn", "btn-primary", 3, "disabled"], [1, "back-button", 3, "click"], [1, "p-2", "f10", "mTop10"], [3, "stepControl"], [1, "col-10"], ["appearance", "outline", 1, "example-chip-list", "chips-contianer", "w100"], ["aria-label", "Course selection"], ["chipList", ""], [3, "selectable", "removable", "removed", 4, "ngFor", "ngForOf"], ["placeholder", "Enter Course", 3, "matChipInputFor", "matChipInputSeparatorKeyCodes", "paste", "matChipInputTokenEnd"], [1, "hint-text"], [1, "col-2", "pt-3"], [1, "btn", "btn-success", 3, "disabled", "click"], ["class", "row mt-4", 4, "ngIf"], [1, "row", "mt-2", "paddingTop10", "dasheedTopBorder"], [1, "col-6"], ["class", "back-button", "matStepperPrevious", "", 4, "ngIf"], [1, "col-6", "text-right"], ["class", "back-button mr-3", 3, "click", 4, "ngIf"], ["matStepperNext", "", 1, "btn", "btn-success"], [1, "col-12"], [1, "w-100", 3, "primaryData", "configurations", "fileUploadSuccess"], ["matStepperPrevious", "", 1, "back-button"], ["class", "col-8 text-right", 4, "ngIf"], [1, "invalid-message"], ["formControlName", "stateProvinceCode", "optionLabel", "stateProvinceName", "optionValue", "stateProvinceCode", "placeholder", "Select State", 1, "w-100", 3, "options"], ["name", "addState", "formControlName", "stateProvinceName", "type", "text", "placeholder", "State", 1, "im-input", "mw-100"], ["confirmModelKey", "savedraftdegree", 1, "mr-3", 3, "disabled", "formToBeSaved", "onClickSaveAsDraft"], [3, "selectable", "removable", "removed"], ["matTooltip", "Remove this item", "matChipRemove", "", 4, "ngIf"], ["matTooltip", "Remove this item", "matChipRemove", ""], [1, "row", "mt-4"], [1, "im-card-no-border-table", 2, "width", "100%"], ["class", "col-md-12", 4, "ngFor", "ngForOf"], [1, "col-md-12"], [1, "w40"], [1, "circleIndex", "rounded-circle"], [1, "col-md-10"], [1, "col-md-2", 2, "cursor", "pointer", 3, "click"], ["matTooltip", "Delete", 4, "ngIf"], ["matTooltip", "Delete"], [1, "back-button", "mr-3", 3, "click"], [1, "col-8", "text-right"], ["class", "btn btn-primary", "matStepperNext", "", 3, "click", 4, "ngIf"], ["matStepperNext", "", 1, "btn", "btn-primary", 3, "click"], [3, "matColumnDef"], ["mat-header-cell", "", 4, "matHeaderCellDef"], ["mat-header-cell", ""], ["mat-cell", ""], ["class", "toggle-col", 4, "ngIf"], ["class", "row", "style", "width:100px;", 4, "ngIf"], [1, "toggle-col"], ["matTooltip", "View more", 1, "mr-1", "icn"], [1, "row", 2, "width", "100px"], ["matTooltip", "Edit", 1, "im-table-verticle-icon", 3, "click"], ["matTooltip", "Delete", 1, "mr-1", "icn", 3, "click"], [1, "example-element-detail"], ["class", "w100 example-element-description py-1", 4, "ngIf"], [1, "w100", "example-element-description", "py-1"], [1, "table", "table-striped"], ["class", "border border-dark", 4, "ngFor", "ngForOf"], [1, "border", "border-dark"], ["nowrap", ""], [1, "im-card-no-border-table"], ["aria-hidden", "true", 1, "fa", "fa-download", "fa-lg", "icn"], [4, "ngFor", "ngForOf"], ["pButton", "", "type", "button", "icon", "pi pi-download", "pTooltip", "Download", 1, "p-button-text", "p-button-rounded", "p-3", 3, "click"], ["mat-header-row", ""], ["mat-row", "", 1, "example-element-row", 3, "click"], ["mat-row", "", 1, "example-detail-row"]], template: function AddEducationDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵtemplate(1, AddEducationDetailsComponent_ng_container_1_Template, 147, 43, "ng-container", 0);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div");
        i0.ɵɵelementStart(3, "div", 1);
        i0.ɵɵelementStart(4, "div");
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div");
        i0.ɵɵelementStart(7, "table", 2);
        i0.ɵɵtemplate(8, AddEducationDetailsComponent_ng_container_8_Template, 3, 1, "ng-container", 3);
        i0.ɵɵelementContainerStart(9, 4);
        i0.ɵɵtemplate(10, AddEducationDetailsComponent_td_10_Template, 4, 4, "td", 5);
        i0.ɵɵelementContainerEnd();
        i0.ɵɵtemplate(11, AddEducationDetailsComponent_tr_11_Template, 1, 0, "tr", 6);
        i0.ɵɵtemplate(12, AddEducationDetailsComponent_tr_12_Template, 1, 2, "tr", 7);
        i0.ɵɵtemplate(13, AddEducationDetailsComponent_tr_13_Template, 1, 0, "tr", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isExternalEmployeeId);
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate1("", ctx.educationDetails.length > 0 ? ctx.educationDetails.length : "No", " Degrees Added by you");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("dataSource", ctx.dataSource);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.columns);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("matHeaderRowDef", ctx.displayedColumns);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("matRowDefColumns", ctx.displayedColumns);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("matRowDefColumns", i0.ɵɵpureFunction0(7, _c2));
    } }, directives: [i10.NgIf, i11.MatTable, i10.NgForOf, i11.MatColumnDef, i11.MatCellDef, i11.MatHeaderRowDef, i11.MatRowDef, i12.MatAccordion, i12.MatExpansionPanel, i13.MatCard, i14.MatHorizontalStepper, i14.MatStep, i5.ɵangular_packages_forms_forms_ba, i5.NgControlStatusGroup, i5.FormGroupDirective, i14.MatStepLabel, i10.NgClass, i15.Dropdown, i5.NgControlStatus, i5.FormControlName, i5.DefaultValueAccessor, i5.MaxLengthValidator, i16.YearDatePickerLibraryComponent, i17.MatFormField, i18.MatInput, i19.MatDatepickerInput, i19.MatDatepickerToggle, i17.MatSuffix, i19.MatDatepicker, i14.MatStepperNext, i20.MatChipList, i20.MatChipInput, i17.MatHint, i21.FileUploadDeafultLibraryComponent, i14.MatStepperPrevious, i22.SaveAsDraftComponent, i20.MatChip, i23.MatIcon, i24.MatTooltip, i20.MatChipRemove, i11.MatHeaderCellDef, i11.MatHeaderCell, i11.MatCell, i25.ButtonDirective, i26.Tooltip, i11.MatHeaderRow, i11.MatRow], styles: [".f10[_ngcontent-%COMP%]{font-size:12px;color:#afaaaa}.dasheedTopBorder[_ngcontent-%COMP%]{border-top:1px dashed grey}.paddingTop10[_ngcontent-%COMP%]{padding-top:10px}.formBox[_ngcontent-%COMP%], .mTop10[_ngcontent-%COMP%]{margin-top:10px!important}.formBox[_ngcontent-%COMP%]{border-top:1px solid grey}.w100[_ngcontent-%COMP%]{width:100%!important}.mLeft[_ngcontent-%COMP%]{margin-left:2rem}.childBtn.firstBtn[_ngcontent-%COMP%]{border-radius:30px 0 0 30px!important;border-right:-1px solid #dedede!important;border-left:0!important}.childBtn.lastBtn[_ngcontent-%COMP%]{border-bottom-right-radius:30px!important;border-top-right-radius:30px!important;border-right:0!important;border-left:-1px solid #dedede!important}.viewType[_ngcontent-%COMP%] > .childBtn.firstBtn[_ngcontent-%COMP%]{border-right:.75px solid grey!important;border-left:none!important}.viewType[_ngcontent-%COMP%] > .childBtn.lastBtn[_ngcontent-%COMP%]{border-right:none!important;border-left:.75px solid grey!important}.add-placeholder[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{padding:0 16px!important}.disabledView[_ngcontent-%COMP%]{pointer-events:none}table[_ngcontent-%COMP%]{width:100%}tr.example-detail-row[_ngcontent-%COMP%]{height:0}tr.example-element-row[_ngcontent-%COMP%]:not(.example-expanded-row):hover{background:#f5f5f5}tr.example-element-row[_ngcontent-%COMP%]:not(.example-expanded-row):active{background:#efefef}.example-element-row[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{border-bottom-width:0}.example-element-detail[_ngcontent-%COMP%]{overflow:hidden}.example-element-diagram[_ngcontent-%COMP%]{min-width:80px;border:2px solid #000;padding:8px;font-weight:lighter;margin:8px 0;height:104px}.example-element-symbol[_ngcontent-%COMP%]{font-weight:700;font-size:40px;line-height:normal}.example-element-description[_ngcontent-%COMP%]{padding:16px}.example-element-description[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:nth-child(odd){background:#d3d3d3}.bgGray[_ngcontent-%COMP%]{background-color:#d3d3d3!important}.w40[_ngcontent-%COMP%]{width:40px!important}"], data: { animation: [
            trigger('detailExpand', [
                state('collapsed', style({ height: '0px', minHeight: '0' })),
                state('expanded', style({ height: '*' })),
                transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
            ]),
        ] } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddEducationDetailsComponent, [{
        type: Component,
        args: [{
                selector: 'add-education-details',
                templateUrl: './add-education-details.component.html',
                styleUrls: ['./add-education-details.component.scss'],
                animations: [
                    trigger('detailExpand', [
                        state('collapsed', style({ height: '0px', minHeight: '0' })),
                        state('expanded', style({ height: '*' })),
                        transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
                    ]),
                ]
            }]
    }], function () { return [{ type: i1$1.CacheCountryListService }, { type: AddEducationDetailsService }, { type: i3.ToastrService }, { type: i0.ChangeDetectorRef }, { type: i4.ReferenceLibraryService }, { type: i5.FormBuilder }, { type: i6.ActivatedRoute }, { type: i7.MatDialog }, { type: i8.Store }, { type: i9.DynamicDialogConfig }, { type: i9.DialogService }]; }, { editEduData: [{
            type: Input
        }], mode: [{
            type: Input
        }], showFileUploadSection: [{
            type: Input
        }], isViewMode: [{
            type: Input
        }], caseRequestShowDivs: [{
            type: Input
        }], accordion: [{
            type: ViewChildren,
            args: [MatAccordion]
        }], educationList: [{
            type: Input
        }], paginator: [{
            type: ViewChild,
            args: [MatPaginator, { static: true }]
        }], sort: [{
            type: ViewChild,
            args: [MatSort, { static: true }]
        }], enableEdit: [{
            type: Output
        }], removeElement: [{
            type: Output
        }] }); })();

class AddEducationDetailsModule {
}
AddEducationDetailsModule.ɵfac = function AddEducationDetailsModule_Factory(t) { return new (t || AddEducationDetailsModule)(); };
AddEducationDetailsModule.ɵmod = i0.ɵɵdefineNgModule({ type: AddEducationDetailsModule });
AddEducationDetailsModule.ɵinj = i0.ɵɵdefineInjector({ providers: [], imports: [[
            YearDatePickerLibraryModule,
            MatSidenavModule,
            MatExpansionModule,
            MatFormFieldModule,
            MatInputModule,
            MatDividerModule,
            MatCardModule,
            MatDatepickerModule,
            MatMomentDateModule,
            MatNativeDateModule,
            MatStepperModule,
            MatSlideToggleModule,
            MatSelectModule,
            AvatarModule,
            CommonModule,
            ReactiveFormsModule,
            MatIconModule,
            MatTabsModule,
            MatSlideToggleModule,
            MatPaginatorModule,
            MatTableModule,
            FormsModule,
            MatTooltipModule,
            MatChipsModule,
            NgxMaskModule.forChild(),
            MatDialogModule,
            PrimengLibraryModule,
            FileUploadDeafultLibraryModule,
            FileDownloadLibraryModule,
            SaveAsDraftModule,
            DeleteDialogLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(AddEducationDetailsModule, { declarations: [AddEducationDetailsComponent], imports: [YearDatePickerLibraryModule,
        MatSidenavModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatInputModule,
        MatDividerModule,
        MatCardModule,
        MatDatepickerModule,
        MatMomentDateModule,
        MatNativeDateModule,
        MatStepperModule,
        MatSlideToggleModule,
        MatSelectModule,
        AvatarModule,
        CommonModule,
        ReactiveFormsModule,
        MatIconModule,
        MatTabsModule,
        MatSlideToggleModule,
        MatPaginatorModule,
        MatTableModule,
        FormsModule,
        MatTooltipModule,
        MatChipsModule, i1$2.NgxMaskModule, MatDialogModule,
        PrimengLibraryModule,
        FileUploadDeafultLibraryModule,
        FileDownloadLibraryModule,
        SaveAsDraftModule,
        DeleteDialogLibraryModule], exports: [AddEducationDetailsComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddEducationDetailsModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    AddEducationDetailsComponent
                ],
                providers: [],
                entryComponents: [],
                exports: [
                    AddEducationDetailsComponent,
                ],
                bootstrap: [],
                imports: [
                    YearDatePickerLibraryModule,
                    MatSidenavModule,
                    MatExpansionModule,
                    MatFormFieldModule,
                    MatInputModule,
                    MatDividerModule,
                    MatCardModule,
                    MatDatepickerModule,
                    MatMomentDateModule,
                    MatNativeDateModule,
                    MatStepperModule,
                    MatSlideToggleModule,
                    MatSelectModule,
                    AvatarModule,
                    CommonModule,
                    ReactiveFormsModule,
                    MatIconModule,
                    MatTabsModule,
                    MatSlideToggleModule,
                    MatPaginatorModule,
                    MatTableModule,
                    FormsModule,
                    MatTooltipModule,
                    MatChipsModule,
                    NgxMaskModule.forChild(),
                    MatDialogModule,
                    PrimengLibraryModule,
                    FileUploadDeafultLibraryModule,
                    FileDownloadLibraryModule,
                    SaveAsDraftModule,
                    DeleteDialogLibraryModule
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of add-education-details
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AddEducationDetailsComponent, AddEducationDetailsModule, AddEducationDetailsService, DeleteDialogConfigurations };
//# sourceMappingURL=add-education-details.js.map
